var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#460052",
    fillRule: "evenodd",
    d: "M12.842 10.39h-.012l-4.152-.066a.69.69 0 0 1-.676-.688V5.192a.688.688 0 0 1 1.375 0v.29a3.534 3.534 0 0 0 3.476 3.534.688.688 0 0 1-.011 1.375M9 .064C4.072.063.063 4.072.063 9S4.072 17.938 9 17.938s8.938-4.01 8.938-8.938S13.928.063 9 .063",
    clipRule: "evenodd"
  })));
};
export default SvgTime;